<template>

  <v-footer class="blue darken-2" 
    v-if="false"  
    >
    <v-layout row wrap align-center>
      <v-flex xs12>
        <div class="white--text ml-3">
          RESRE LLC
          <a
            class="white--text"
            href="http://www.resilientresidence.com/"
            target="_blank"
          >Resilient Residence</a>
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>
